module.exports = __webpack_public_path__ + "static/media/plus.ce3d4719.svg";